import { Helper } from '@/services/helper/helper'

class EventTrackingWrapper {
  constructor () {
    window.scrollPosition = 0
    window.scrollPosition25 = false
    window.scrollPosition50 = false
    window.scrollPosition75 = false
    window.scrollPosition100 = false

    this.intervals = [2000, 5000, 10000, 20000, 30000, 60000, 120000]
    this.site = window.PageConfig.site === 'hp' ? 'homepage' : 'logout'
    this.init()
  }

  init () {
    if (window.PageConfig.site === 'll') {
      this.initTimeSpentPixel()
    }

    document.addEventListener('DOMContentLoaded', () => {
      // Click Event für die Suche im Header
      if (document.querySelector('[data-component="header"] input[id^="searchbar"]')) {
        document.querySelector('[data-component="header"] input[id^="searchbar"]').addEventListener('click', (event) => {
          window.Tracking.trackMe(
            {
              section: `${this.site}.header.search.focus`,
              trackingtype: 'cl'
            },
            event
          )
        })
      }

      // Click Event für die Suche im inactivity Layer
      if (document.querySelector('[data-component="layer"] input[id^="searchbar"]')) {
        document.querySelector('[data-component="layer"] input[id^="searchbar"]').addEventListener('click', (event) => {
          window.Tracking.trackMe(
            {
              section: `${this.site}.inactivitylayer.search.focus`,
              trackingtype: 'cl'
            },
            event
          )
        })
      }

      // für das Öffnen des Burger Menüs
      if (document.querySelector('[data-component="burger"]')) {
        document.querySelectorAll('[data-component="burger"] > input[type="checkbox"]').forEach((element) => {
          element.addEventListener('change', (event) => {
            if (event.target.checked) {
              const trackObject = {
                section: `${this.site}.navigation.menu.open`,
                trackingtype: 'cl'
              }

              window.Tracking.trackMe(trackObject)
            }
          })
        })
      }

      // für das Öffnen der Bento Menüs
      if (document.querySelector('[data-component="bento"] label')) {
        document.querySelectorAll('[data-component="bento"] label').forEach((element) => {
          element.addEventListener('click', (event) => {
            const trackObject = {
              section: `${this.site}.productselection.open`,
              trackingtype: 'cl',
              cont_mode: window.SiteInfo.stickyLogin ? 'sticky' : ''
            }

            window.Tracking.trackMe(trackObject, event)
          })
        })
      }

      // für die Auswahl im Bento Menü
      if (document.querySelector('[data-component="bento"] [data-component="simple"]')) {
        document.querySelectorAll('[data-component="bento"] [data-component="simple"]').forEach((element) => {
          element.addEventListener('click', (event) => {
            const trackObject = {
              section: `${this.site}.productselection.select`,
              trackingtype: 'cl',
              cont_product: element.querySelector('figcaption')?.innerText.toLowerCase(),
              cont_mode: window.SiteInfo.stickyLogin ? 'sticky' : ''
            }

            window.Tracking.trackMe(trackObject, event)
          })
        })
      }

      // Slider prev/next
      if (document.querySelectorAll('[data-component="slider"] [data-part^="arrow-"]')) {
        document.querySelectorAll('[data-component="slider"] [data-part^="arrow-"]').forEach((element) => {
          element.addEventListener('click', (event) => {
            const trackObject = {
              section: `${this.site}.slider.prev`,
              trackingtype: 'cl',
              cont_block_title: Helper.getAttributeValue(element, 'data-tracking-name')?.toLowerCase()
            }

            if (event.target.dataset.part?.indexOf('arrow-next') > -1) {
              trackObject.section = `${this.site}.slider.next`
            }

            window.Tracking.trackMe(trackObject, event)
          })
        })
      }

      /* Login im Content */
      // sticky/unsticky Login

      let loginStickyChangedFirstCall = true
      document.body.addEventListener('loginStickyChanged', (event) => {
        if (!loginStickyChangedFirstCall) {
          const trackObject = {
            section: `${this.site}.loginformular.sticky.update`,
            trackingtype: 'ev',
            cont_mode: window.SiteInfo.stickyLogin ? 'sticky' : ''
          }

          window.Tracking.trackMe(trackObject)
        } else {
          loginStickyChangedFirstCall = false
        }
      })

      // Passwort sichbar oder nicht Button
      if (document.querySelector('[data-component="login"] [data-type="password"] + [data-component="button"]')) {
        document.querySelector('[data-component="login"] [data-type="password"] + [data-component="button"]').addEventListener('click', (event) => {
          const trackObject = {
            section: `${this.site}.loginformular.password.visible`,
            trackingtype: 'cl',
            cont_mode: window.SiteInfo.stickyLogin ? 'sticky' : ''
          }

          let inputField = document.querySelector('[data-component="login"] [data-type="password"]')

          if (inputField.getAttribute('type') === 'password') {
            trackObject.section = `${this.site}.loginformular.password.invisible`
          }

          window.Tracking.trackMe(trackObject, event)
        })
      }

      // Login Button
      if (document.querySelector('[data-component="login"] [data-form-login] > [data-component="button"]')) {
        document.querySelector('[data-component="login"] [data-form-login] > [data-component="button"]').addEventListener('click', (event) => {
          const trackObject = {
            section: `${this.site}.loginformular.login`,
            trackingtype: 'cl',
            cont_product: document.querySelector('[data-component="login"] [data-login-text]')?.innerText.toLowerCase(),
            cont_mode: window.SiteInfo.stickyLogin ? 'sticky' : ''
          }

          window.Tracking.trackMe(trackObject, event)
        })
      }

      window.addEventListener('scroll', (event) => {
        let scrollPosition = this.getScrollPercent()
        if (window.scrollPosition < scrollPosition) {
          window.scrollPosition = scrollPosition
        }

        if (window.scrollPosition >= 25 && !window.scrollPosition25) {
          window.Tracking.trackMe({
            section: `${this.site}.scroll.25`,
            trackingtype: 'ev'
          })
          window.scrollPosition25 = true
        }
        if (window.scrollPosition >= 50 && !window.scrollPosition50) {
          window.Tracking.trackMe({
            section: `${this.site}.scroll.50`,
            trackingtype: 'ev'
          })
          window.scrollPosition50 = true
        }
        if (window.scrollPosition >= 75 && !window.scrollPosition75) {
          window.Tracking.trackMe({
            section: `${this.site}.scroll.75`,
            trackingtype: 'ev'
          })
          window.scrollPosition75 = true
        }
        if (window.scrollPosition >= 95 && !window.scrollPosition100) {
          window.Tracking.trackMe({
            section: `${this.site}.scroll.100`,
            trackingtype: 'ev'
          })
          window.scrollPosition100 = true
        }
      })
    })

    document.addEventListener('layerOpened', (event) => {
      window.Tracking.trackMe(
        {
          section: `${this.site}.inactivityLayer.view`,
          trackingtype: 'ev'
        },
        event
      )
    })
  }

  initTimeSpentPixel () {
    const timeSince = new Date().getTime() - window.startupTS

    this.intervals.forEach((time, index) => {
      setTimeout(() => {
        window.Tracking.trackMe({
          section: `logout.duration.${index + 1}`,
          trackingtype: 'ev',
          time_spent_page: time / 1000
        })
      }, time - timeSince)
    })
  }

  getScrollPercent () {
    let h = document.documentElement
    let b = document.body
    let st = 'scrollTop'
    let sh = 'scrollHeight'
    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
  }
}

export { EventTrackingWrapper }
